import { useState } from 'react';
import i18n from 'helpers/i18n';
import messages from './messages';
import { useMutation } from '@tanstack/react-query';
import { toastSuccess, toastError } from 'components/Toast';
import {
  parsePasswordApiErrors,
  describePasswordPolicyCode
} from 'helpers/passwordErrors';
import { updatePassword } from 'actions/users';
import { Password } from 'components/Password';
import useCurrentUser from 'hooks/useCurrentUser';
import { Text } from '@teachstonellc/component-library';

function ChangePassword() {
  const currentUser = useCurrentUser();
  const [isSuccess, setIsSuccess] = useState(false);

  const passwordMutation = useMutation({
    mutationFn: (values: any) => updatePassword({ user: { ...values } }),
    onSuccess: () => {
      setIsSuccess(true);
      toastSuccess({ description: i18n.ft(messages.success) });
    },
    onError: (error: any) => {
      const errors = error.response?.data?.errors;
      const description =
        describePasswordPolicyCode(error.response?.data?.error_code) ||
        parsePasswordApiErrors(errors) ||
        i18n.ft(messages.errors.generic);
      toastError({ description });
    }
  });

  function handleSubmit(values: any) {
    passwordMutation.mutate(values);
  }

  return (
    <div className="p-4 rounded-md bg-white shadow-sm border border-neutral-200 first:mt-0 mt-4">
      <Text
        as="h2"
        className="font-bold text-[#58697b] uppercase mb-4 pb-4 text-ds-sm"
      >
        {i18n.ft(messages.changePassword)}
      </Text>

      <Password
        label={i18n.ft(messages.fields.password)}
        confirmLabel={i18n.ft(messages.fields.passwordConfirmation)}
        onSubmit={handleSubmit}
        fieldClasses="grid grid-cols-2 gap-4"
        isSubmitSuccessful={isSuccess}
        submitButtonText={i18n.ft(messages.save)}
        firstName={currentUser.first_name}
        lastName={currentUser.last_name}
        email={currentUser.email}
      />
    </div>
  );
}

export default ChangePassword;
